import React from 'react'
import { ContentHeader } from '../../layout/Content'

function StockInHeader() {
  return ( <ContentHeader title='Stock In'/> )
}

export default React.memo(StockInHeader)
